import axios from "axios";

export const state = {
  salecarts: [],
};

export const getters = {
  salecarts: (state) => state.salecarts,
};

export const mutations = {
  setCart(state, newValue) {
    state.salecarts = newValue;
  },
};

export const actions = {
  async fetchSalesCart({ commit }) {
    await axios.get("/salecart").then((res) => {
      commit("setCart", res.data.carts);
    });
  },
};
